/**
 * Video
 */

import React from 'react';
import { LinkType, StandardImage } from 'types/global';
import {
	VideoContainer,
	Overlay,
	VideoButton,
	VideoIcon,
	VideoButtonText,
} from './Cards.styles';
import Image from 'components/Image';
import Icon from 'components/Icon';

interface Props {
	/** Video src */
	image: StandardImage;
}

/** Container component for Video. */
const Video: React.FC<Props> = ({ image }) => (
	<VideoContainer>
		<Overlay />
		<Image
			src={image.src}
			alt={image.alt}
			srcSet={`
							${image.sizes[0]} 500w,
							${image.sizes[1]} 350w
						`}
			webpSrcSet={`
							${image.webpSizes[0]} 500w,
							${image.webpSizes[1]} 350w
						`}
			sizes="(min-width: 768px) 60vw, (max-width: 767px) 70vw, 350px"
		/>
		<VideoButton>
			<VideoIcon>
				<Icon icon={'arrowRight'} size={0} aria-hidden="true" />
			</VideoIcon>
			<VideoButtonText>Se videon</VideoButtonText>
		</VideoButton>
	</VideoContainer>
);

export default Video;
